import React from 'react';

export default function EnvTest() {
  // Get environment variables
  const envVars = {
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY ? 'SET' : 'NOT SET',
    VITE_GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    VITE_GITHUB_CLIENT_ID: import.meta.env.VITE_GITHUB_CLIENT_ID,
    VITE_MICROSOFT_CLIENT_ID: import.meta.env.VITE_MICROSOFT_CLIENT_ID,
    VITE_SITE_URL: import.meta.env.VITE_SITE_URL,
    MODE: import.meta.env.MODE,
    DEV: import.meta.env.DEV,
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>Environment Variables Test</h1>
      <h2>Current Environment Variables:</h2>
      <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '5px' }}>
        {JSON.stringify(envVars, null, 2)}
      </pre>
      
      <h2>OAuth Configuration Status:</h2>
      <ul>
        <li>Google: {envVars.VITE_GOOGLE_CLIENT_ID ? '✅ CONFIGURED' : '❌ NOT SET'}</li>
        <li>GitHub: {envVars.VITE_GITHUB_CLIENT_ID ? '✅ CONFIGURED' : '❌ NOT SET'}</li>
        <li>Microsoft: {envVars.VITE_MICROSOFT_CLIENT_ID ? '✅ CONFIGURED' : '❌ NOT SET'}</li>
        <li>Site URL: {envVars.VITE_SITE_URL ? '✅ CONFIGURED' : '❌ NOT SET'}</li>
      </ul>

      <h2>Expected Values:</h2>
      <pre style={{ background: '#e8f5e8', padding: '10px', borderRadius: '5px' }}>
VITE_GOOGLE_CLIENT_ID=test_google_client_id
VITE_GITHUB_CLIENT_ID=test_github_client_id  
VITE_MICROSOFT_CLIENT_ID=test_microsoft_client_id
VITE_SITE_URL=http://localhost:8888
      </pre>

      <h2>Current window.location:</h2>
      <p>Origin: {window.location.origin}</p>
      <p>Full URL: {window.location.href}</p>
    </div>
  );
} 